import PropTypes from 'prop-types';
import { requireTemplateByName } from 'lib/dependencies';
import getTemplateName from 'utils/template';

/**
 * Get the page template based on ContentType
 */
export default function PageTemplate(props) {
  const {
    pageMeta: { contentType },
  } = props;
  const template = getTemplateName(contentType);
  const Component = requireTemplateByName(template);
  return <Component {...props} />;
}

PageTemplate.propTypes = {
  pageMeta: PropTypes.shape({
    contentType: PropTypes.string.isRequired,
  }).isRequired,
};
